module.exports = __webpack_public_path__ + "media/flags/016-spain-c82f2a10.svg";